import { render, staticRenderFns } from "./ReviewFileHarvester.vue?vue&type=template&id=66460aa3&"
import script from "./ReviewFileHarvester.vue?vue&type=script&lang=ts&"
export * from "./ReviewFileHarvester.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports